// extracted by mini-css-extract-plugin
export default {"page":"page-page-Kte645","backToTop":"page-backToTop-W3jXbs"};